"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerPaymentProcessorOnboardingApplicationStatus = exports.HaulerPaymentProcessorOnboardingTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.HaulerPaymentProcessorOnboardingTransport = typebox_1.Type.Object({
    merchantID: typebox_1.Type.String(),
    merchantApplicationID: typebox_1.Type.String(),
});
exports.HaulerPaymentProcessorOnboardingApplicationStatus = {
    NOT_SUBMITTED: 'NOT_SUBMITTED',
    PENDING: 'PENDING',
    COMPLETE: 'COMPLETE',
    DECLINED: 'DECLINED',
};
//# sourceMappingURL=hauler-payment-processing.js.map